import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { IProgessBarWizardComponent, ProgressBarWizardButtonAlignment } from './iprogressbar.wizard.component';
import { ProgressBarWizardEvents } from './progressbar.wizard.events';

@Component({
    selector: 'progressbar-wizard',
    templateUrl: './progressbar.wizard.html',
    styleUrls: ['./progressbar.wizard.css']
})
export class ProgressBarWizard implements OnInit, AfterViewInit, OnDestroy {

    ProgressBarLabelStyle = {};
    ProgressBarValue = 0;
    PageCaption = '';

    WizardPagesValue = [];
    @Input()
    get WizardPages() {
        return this.WizardPagesValue;
    }
    set WizardPages(val) {
        this.WizardPagesValue = val;
    }

    ButtonAlignmentValue = ProgressBarWizardButtonAlignment.Separated;
    @Input()
    get ButtonAlignment() {
        return this.ButtonAlignmentValue;
    }
    set ButtonAlignment(val) {
        this.ButtonAlignmentValue = val;
    }    

    currentIndex: number = 0;
    ShowButtons = true;
    WizardState = {};
    Component: IProgessBarWizardComponent;
    Subscriptions = [];
    @ViewChild('dynamic', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;

    constructor(private cdRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.Subscriptions.push(ProgressBarWizardEvents.GoTo.subscribe((index) => {
            if (index <= 0) {
                this.currentIndex = 0;
            } else if (index >= this.WizardPagesValue.length - 1) {
                this.currentIndex = this.WizardPagesValue.length - 1;
            } else {
                this.currentIndex = index;
            }
            this.setCurrentControl();
        }));
        this.Subscriptions.push(ProgressBarWizardEvents.DetectChanges.subscribe(() => {
            this.cdRef.detectChanges();
        }));
        this.Subscriptions.push(ProgressBarWizardEvents.ShowButtons.subscribe((show) => {
            this.ShowButtons = show;
            this.cdRef.detectChanges();
        }));
        if (this.WizardPagesValue) {
            const list = [];
            this.WizardPagesValue.forEach(() => {
                list.push('1fr');
            });
            this.ProgressBarLabelStyle = {
                'grid-template-columns': list.join(' ')
            };
        }
    }

    ngOnDestroy(): void {
        this.Subscriptions.forEach((sub: any) => {
            sub.unsubscribe();
        });
        this.Subscriptions.splice(0);
    }

    ngAfterViewInit(): void {
        this.setCurrentControl();
    }

    setCurrentControl() {
        // Check if there's already a component instance
        if (this.Component) {
            this.Component.UpdateWizardState();
        }

        // Update ProgressBar
        if (this.currentIndex <= 0) {
            this.ProgressBarValue = 100 / (this.WizardPagesValue.length * 4);
        } else if (this.currentIndex == this.WizardPagesValue.length - 1) {
            this.ProgressBarValue = 100;
        } else {
            this.ProgressBarValue = (this.currentIndex * 2 + 1) * 100 / (this.WizardPagesValue.length * 2);
        }

        // Check if the view container reference is available to host the dynamic component
        if (this.viewContainerRef) {
            // Clear the view container of any previous content
            this.viewContainerRef.clear();

            // Ensure the valList is defined and the currentIndex is within its bounds
            if (this.currentIndex > -1 && this.currentIndex < this.WizardPagesValue.length) {
                // Get the current item from valList based on currentIndex
                const actVal = this.WizardPagesValue[this.currentIndex];
                // Check if the current item is valid and has a Content property
                if (actVal && actVal.Content) {
                    this.PageCaption = actVal.Caption;
                    // Create the component in the view container
                    const comp = this.viewContainerRef.createComponent(actVal.Content);
                    // Store the component instance
                    this.Component = <IProgessBarWizardComponent>comp.instance;
                    // Pass the wizard state to the component instance
                    this.Component.SetWizardState(this.WizardState);
                }
            }
        }
        this.cdRef.detectChanges();
    }

    nextItem(): void {
        if (this.currentIndex < this.WizardPagesValue.length - 1) {
            this.currentIndex = this.currentIndex + 1;
            this.setCurrentControl();
        }
    }

    prevItem(): void {
        if (this.currentIndex > 0) {
            this.currentIndex = this.currentIndex - 1;
            this.setCurrentControl();
        }
    }
}
